import React from 'react';
import './CompanyPages.css';
import useScrollToTop from '../components/useScrollToTop';
import Seo from '../components/Seo';
import AllPosts from '../components/AllPosts';
import LatestArticles from '../components/LatestArticles';
import RecentPostsWidget from '../components/RecentPostsWidget';
import blogPostsData from '../components/blogPostsData';

const Blog = () => {
  useScrollToTop();

  const allCategories = [...new Set(blogPostsData.flatMap((post) => post.tags))];

const blogSeo = {
  title: 'Housekaar Construction Blog: Insights & Inspiration',
  description:
    'Discover insightful articles, expert tips, and the latest trends in architecture, interior design, and construction from Housekaar Construction in Patna.',
  keywords: allCategories.join(', ') + ', architecture blog, interior design blog, construction tips Patna',
  imageUrl: '/images/blog-banner.jpg',
};

  return (
    <div className="company-page blog-page">
      <Seo {...blogSeo} location="Patna" />

      <section className="blog-header">
        <h1>The Housekaar Blog</h1>
        <p className="lead">
          Your source for the latest insights, trends, and expert advice in architecture, interior design, and home construction in Patna and beyond.
        </p>
      </section>

      <div className="blog-content-wrapper">
        <main className="blog-main">
        <LatestArticles blogPosts={blogPostsData} />

          <AllPosts posts={blogPostsData} />
        </main>

        <aside className="blog-sidebar">
     {/*    <section className="categories-widget">
            <h3>Categories</h3>
            <ul>
              {allCategories.map((category) => (
                <li key={category}>
                  <Link to={`/blog/category/${category.toLowerCase().replace(/\s+/g, '-')}`}>{category}</Link>
                </li>
              ))}
            </ul>
          </section>*/}

<RecentPostsWidget blogPosts={blogPostsData} />
{/*
          <section className="tags-widget">
            <h3>Tags</h3>
            <div className="tag-cloud">
              {allCategories.map((tag) => (
                <Link key={tag} to={`/blog/tag/${tag.toLowerCase().replace(/\s+/g, '-')}`} className="tag-link">
                  {tag}
                </Link>
              ))}
            </div>
          </section>*/}
        </aside>
      </div>
    </div>
  );
};

export default Blog;